import React from 'react';
import styles from '../Operations.module.css';

interface PEFFComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * PEFF - Pricing Effectiveness
 * KPI information component
 */
const PEFF: PEFFComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        <strong>Pricing Effectiveness:</strong><br />
         Ace&apos;s retail pricing strategy is to price at an overall premium to Home Depot and Lowe&apos;s.  We offer Service, Quality and Convenience that cannot be matched by the big boxes, which allows us to charge this premium to our customers. However, it is important for us to watch this premium to make sure it does not get too large and start pushing our customers over to the competition.  We can monitor this together by looking at Competitive Price Index (CPI) and Year-Over-Year Transactions (YoY Trans) as indicators for when store pricing may be driving customers away and putting sales at risk. Taken together, CPI and YoY Trans are called Pricing Effectiveness. 
      </div>

       <div className={styles.sectionContent}>
        <strong>Competitive Price Index (CPI):</strong><br />
         Ace monitors competitive pricing across more than 50,000 products on a regular basis to make sure Ace recommended retails are competitive. This data is used to calculate a Competitive Price Index or CPI, which is a comparison of Ace price vs Competition price. A CPI of 100% means that Ace price matches the competition, whereas a CPI of 115% means that Ace price is 15% higher than competition. 
         <br /><br />
          In creating the Pricing Effectiveness metric, we are building store specific CPI&apos;s using store retail vs an average of Home Depot and Lowe&apos;s retail.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

       <div className={styles.sectionContent}>
        Clicking the Pricing Effectiveness link will give options to drill down into the next level of CPI and YoY Trans data.<br /><br />
         This can be done at different hierarchy levels all the way down to SKU level detail. 
      </div>

      
      <div className={styles.sectionTitle}>
        Update Cadence 
      </div>

       <div className={styles.sectionContent}>
       Metric is monthly but data details are daily 
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div style={{ marginBottom: '15px', overflowX: 'auto' }}>
        <table style={{ 
          width: '100%', 
          borderCollapse: 'collapse', 
          fontSize: '14px',
          minWidth: '600px'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#FF0000', color: 'white' }}>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Scenario</th>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>CPI Value</th>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>YoY Trans Value</th>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Pricing Effectiveness Result</th>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Retailer Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>1</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>&gt;=125%</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>&gt; 0</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Pricing Risk: Medium (Yellow)</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Pricing above target range may be limiting growth or putting future growth at risk - Review high CPI items for price decreases</td>
            </tr>
            <tr>
              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>2</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>&gt;=110%, &lt;125%</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>&gt; 0</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Pricing Risk: Low (Green)</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Pricing within target range with growing customer counts - No pricing actions needed at this time</td>
            </tr>
            <tr>
              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>3</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>&lt;110%</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>&gt; 0</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Pricing Risk: Medium (Yellow)</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Pricing below target range may be limiting store profitability - Review low CPI items for price increases</td>
            </tr>
            <tr>
              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>4</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>&gt;=120%</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>&lt;= 0</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Pricing Risk: High (Red)</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Pricing above target range likely limiting growth - Review high CPI items for price decreases</td>
            </tr>
            <tr>
              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>5</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>&gt;=110%, &lt;120%</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>&lt;= 0</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Pricing Risk: Low (Green)</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Pricing within target range with growth at or below last year - No pricing actions needed at this time, explore other growth levers</td>
            </tr>
            <tr>
              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>6</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>&lt;110%</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>&lt;= 0</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Pricing Risk: Medium (Yellow)</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>Pricing below typical range may be limiting store profitability, without driving significant growth - Review low CPI items for price increases</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className={styles.sectionTitle}>
        Drill Down
      </div>

      <div className={styles.sectionContent}>
        1. Review Ace Way of Retailing documentation on Ace Retail Pricing for further detail (AWOR &gt; Marketing & Promotions - Retail Pricing &gt; Ace Pricing &gt; Best Practices - Retail Pricing).
        <br/><br/>
        2. Use drill-down functionality to identify areas that require pricing review. 
        <br /><br />
        3.Leverage the item-level detail to determine where some retails may be too high and need to be lowered to improve competitive position. 
        <br/><br/>
        For assistance, retailers can reach out to retailpricing@acehardware.com.
      </div>

    

      <div className={styles.sectionTitle}>
        Learn More
      </div>

      <div className={styles.sectionContent}>
        Use drill-down functionality to identify areas that require pricing review.<br/>
        Leverage the item-level detail to determine where some retails may be too high and need to be lowered in order to improve competitive position.<br/>
        For assistance, retailers can reach out to{' '}
        <a
          href="mailto:retailpricing@acehardware.com"
          className={styles.link}>
          retailpricing@acehardware.com
        </a>.
      </div>
    </div>
  );
};

PEFF.title = 'Pricing Effectiveness';
PEFF.actionTitle = 'Review Pricing Issues';
PEFF.actionHyperlink = '';
export default PEFF;


